export default "__VITE_ASSET__B$EV3q9V__"